<script setup>

import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import Button from 'primevue/button';

const props = defineProps({
    activeIndex: Number,
    selectJobs: Array,
    retry: Function,
    destroy: Function,
    getJobs: Function,
    clearFilter: Function,
    clearSort: Function
});

const emit = defineEmits(['update:activeIndex', 'clearSelectedJobs']);

const onTabChange = (index) => {
    emit('update:activeIndex', index);
    emit('clearSelectedJobs');
    props.clearFilter();
    props.clearSort();
    props.getJobs();
}

</script>

<template>
    <TabList class="tab-list">
        <div class="d-flex justify-content-center align-items-center">
            <Tab value="0" @click="onTabChange(0)">Jobs</Tab>
            <Tab value="1" @click="onTabChange(1)">Jobs falhados</Tab>
        </div>

        <div class="d-flex flex-row flex-wrap justify-content-end align-items-center gap-2 ms-auto">
            <Button
                v-if="selectJobs.length && activeIndex === 1"
                raised rounded
                icon="pi pi-refresh"
                label="Reprocessar"
                title="Reprocessar"
                @click="retry">
            </Button>

            <Button
                v-if="selectJobs.length"
                raised rounded
                icon="pi pi-trash"
                label="Excluir"
                title="Excluir"
                @click="destroy">
            </Button>

            <Button icon="pi pi-refresh" rounded raised @click="getJobs"></Button>
        </div>
    </TabList>
</template>
